import {
  TimeAttackScoringBase,
  isTimeAttackScoringType,
} from "model/Match/Set/TimeAttack/Track/Scoring/TimeAttackScoring";
import { mapTimeAttackScoringAverage } from "./FsTimeAttackScoringAverage";
import { mapTimeAttackScoringSum } from "./FsTimeAttackScoringSum";
import {
  FsTimeAttackScoring,
  FsTimeAttackScoringBase,
} from "db/model/match/Set/TimeAttack/Scoring/FsTimeAttackScoring";
import { isFsTimeAttackScoringAverage } from "db/model/match/Set/TimeAttack/Scoring/FsTimeAttackScoringAverage";
import { isFsTimeAttackScoringSum } from "db/model/match/Set/TimeAttack/Scoring/FsTimeAttackScoringSum";
import { isFsTimeAttackScoringPoints } from "db/model/match/Set/TimeAttack/Scoring/FsTimeAttackScoringPoints";
import { mapTimeAttackScoringPoints } from "./FsTimeAttackScoringPoints";

export const mapTimeAttackScoringBase = (
  fsModel: FsTimeAttackScoringBase
): TimeAttackScoringBase | undefined => {
  if (!fsModel.type || !isTimeAttackScoringType(fsModel.type)) {
    return undefined;
  }

  return {
    type: fsModel.type,
  };
};

export const mapTimeAttackScoring = (fsModel: FsTimeAttackScoring) => {
  const base = mapTimeAttackScoringBase(fsModel);
  if (!base) {
    return undefined;
  }

  if (isFsTimeAttackScoringAverage(fsModel)) {
    return mapTimeAttackScoringAverage(base, fsModel);
  }

  if (isFsTimeAttackScoringPoints(fsModel)) {
    return mapTimeAttackScoringPoints(base, fsModel);
  }

  if (isFsTimeAttackScoringSum(fsModel)) {
    return mapTimeAttackScoringSum(base, fsModel);
  }

  return undefined;
};
